import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import VenoBox from 'venobox';
import 'venobox/dist/venobox.min.css';
import siteQueries from '../../queries/siteQueries';
import Loader from './Loader';
import MainHeader from './MainHeader';
import Pagination from '../../common/Pagination/Pagination';
import Footer from './Footer';
import BannerBg from '../../images/cover/inner-banner-bg.jpg';

export default function VideoListSite() {
    const [isOpen, setIsOpen] = useState(false);
    const [video, setVideo] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(20);
    const [totalPage, setTotalPage] = useState(0);
    const [isLoading, setIsLoading] = useState(true);

    const navigate = useNavigate();
    const handleClose = () => setIsOpen(false);
    const handleOpen = () => setIsOpen(true);

    const videoData = siteQueries.useVideoMutation(
        async (response) => {
            setVideo(response?.data?.items);
            setTotalCount(response?.data?.totalItems);
            setTotalPage(response?.data?.totalPages);
            setIsLoading(false);
        },
    );

    useEffect(() => {
        videoData.mutateAsync({
            page: currentPage,
            size: pageSize,
        });
    }, [currentPage, pageSize]);

    useEffect(() => {
        const venobox = new VenoBox({
            selector: '.venobox',
            numeration: true,
            infinigall: true,
            share: true,
            spinner: 'rotating-plane',
            spinColor: '#F4D03F',
            titleattr: 'data-title',
            titlePosition: 'top',
            titleStyle: 'bar',
            cb_init: function () {
                console.log('VenoBox initialized');
            },
            cb_post_open: function () {
                console.log('Video opened');
            },
            cb_pre_close: function () {
                const iframe = document.querySelector('.vbox-content iframe');
                if (iframe) {
                    const src = iframe.src;
                    iframe.src = src;
                }
            }
        });
        return () => { };
    }, [video]);

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    const totalPages = totalPage;

    const getYoutubeId = (link) => {
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = link.match(regExp);
        return (match && match[2].length === 11) ? match[2] : null;
    };

    useEffect(() => {
        document.title = `Videos | International Literature Festival of Kerala 2025`;
        return () => {
            document.title = 'ILFK 2025 | International Lit Fest | Literature Festival | Literary Festival 2025';
        };
    }, []);

    return (
        <div className="min-h-screen bg-slate-50 from-gray-100 to-gray-200 videoContainer">
            <MainHeader />
            {isLoading ? (
                <Loader />
            ) : (
                <>
                    {/* Banner */}
                    <div className="min-h-[190px] flex justify-center items-center text-bla py-4 relative overflow-hidden" style={{
                        backgroundImage: `url(${BannerBg})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                    }}>
                        <div className="relative z-5 text-center px-4">
                            <h1 className="text-4xl sm:text-2xl font-bold drop-shadow-md">
                                <span className="text-yellow-400 text-[36px]">Videos</span>
                            </h1>
                            <p className="text-white text-[15px] sm:text-[18px] mt-2 font-semibold opacity-90">
                                Stay updated with the latest from International Literature Festival of Kerala 2025
                            </p>
                        </div>
                    </div>

                    <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 py-5">
                        {/* Stats */}
                        <div className="text-left border-b p-4 mb-6">
                            <p className="text-gray-600 text-[16] text-[#000]">
                                Showing <span className="font-semibold">{video.length}</span> of{' '}
                                <span className="font-semibold">{totalCount}</span> videos articles
                            </p>
                        </div>
                    </div>

                    {/* Videos */}
                    <div className="container mx-auto px-2 py-8 videoCards">
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                            {video?.map((item, index) => (
                                <div key={index} className="rounded overflow-hidden shadow-md hover:shadow-xl transition duration-300 bg-white">
                                    <a
                                        className="venobox block"
                                        data-vbtype="video"
                                        data-autoplay="true"
                                        href={item?.link}
                                        data-title={item?.title}
                                    >
                                        <img
                                            className="w-full h-48 object-cover"
                                            src={`https://img.youtube.com/vi/${getYoutubeId(item?.link)}/hqdefault.jpg`}
                                            alt={item?.title}
                                        />
                                    </a>
                                    <div className="p-4">
                                        <p className="font-medium text-sm text-gray-800">{item?.title}</p>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {/* Pagination */}
                        <div className="flex justify-center mt-8">
                            <Pagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                onPageChange={handlePageChange}
                            />
                        </div>
                    </div>
                </>
            )}
            <Footer />
        </div>
    );
}
